import axios from "axios";
import { generalAppInfo } from "./constants";

export const LOCALHOST = "localhost";
export const PROD_BASEURL = "truq.it";
export const BETA_BASEURL = "beta.mytruq.com";
export const CHECKOUT_PROD_BASEURL = "checkout.siju.it";
export const CHECKOUT_BETA_BASEURL = "dodge-checkout-beta.vercel.app";
export const FIREBASE_STAGING_BASEURL = "dodge-multiview-staging.web.app";
export const FIREBASE_PRODUCTION_BASEURL = "dodge-checkout-production.web.app";


export const getBaseUrlEnv = () => {
  if (typeof window !== "undefined") {
    if (
      window.location.hostname === LOCALHOST ||
      window.location.hostname === BETA_BASEURL ||
      window.location.hostname === CHECKOUT_BETA_BASEURL ||
      window.location.hostname === FIREBASE_STAGING_BASEURL
    ) return "SANDBOX";
    else return "PRODUCTION";
  }
};

// export const getBaseUrl = () => {
//   let web = "";
//   if (
//     window.location.hostname === LOCALHOST ||
//     window.location.hostname === BETA_BASEURL ||
//     window.location.hostname === CHECKOUT_BETA_BASEURL || window.location.hostname === FIREBASE_STAGING_BASEURL
//   ) {
//     web = generalAppInfo.DODGE_STAGING_BASE_URL;

//   } else if (
//     window.location.hostname === PROD_BASEURL ||
//     window.location.hostname === CHECKOUT_PROD_BASEURL ||
//     window.location.hostname === FIREBASE_PRODUCTION_BASEURL
//   ) { web = generalAppInfo.DODGE_BASE_URL; }

//   return { web };
// };


export const getBaseUrl = () => {
  const hostname = window.location.hostname;
  let web = "";

  const isStaging = [
    LOCALHOST,
    "127.0.0.1",
    BETA_BASEURL,
    CHECKOUT_BETA_BASEURL,
    FIREBASE_STAGING_BASEURL,
  ].includes(hostname);

  const isProduction = [
    PROD_BASEURL,
    CHECKOUT_PROD_BASEURL,
    FIREBASE_PRODUCTION_BASEURL,
  ].includes(hostname);

  if (isStaging) {
    web = generalAppInfo.DODGE_STAGING_BASE_URL;

  } else if (isProduction) {
    web = generalAppInfo.DODGE_BASE_URL;

  } else {
    console.log("");
  }

  return { web };
};

let dodgeInstance;

if (typeof window !== "undefined") {
  dodgeInstance = axios.create({ baseURL: getBaseUrl()['web'] });

  dodgeInstance.interceptors.request.use(config => {
    const token = getBaseUrlEnv() === 'PRODUCTION'
      ? generalAppInfo.SIJU_PK
      : generalAppInfo.SIJU_STAGING_PK;

    config.headers = {
      Authorization: `Bearer ${token}`,
      ...config.headers
    };
    return config;
  }, error => Promise.reject(error));

  dodgeInstance.interceptors.response.use(
    response => response,
    error => error.response
  );
}

export { dodgeInstance };
// const dodgeInstance = axios.create({ baseURL: getBaseUrl()['web'] });

// dodgeInstance.interceptors.request.use(config => {
//   const token = getBaseUrlEnv() === 'PRODUCTION' ? generalAppInfo.SIJU_PK : generalAppInfo.SIJU_STAGING_PK;
//   config.headers = { Authorization: `Bearer ${token}`, ...config.headers }
//   return config;
// }, error => Promise.reject(error));

// dodgeInstance.interceptors.response.use(response => response, error => {
//   return error.response;
// });

// export { dodgeInstance };
